import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="sticky top-0 z-40 w-full bg-plum-700 py-2.5 text-white" data-id="element-219" data-mp="32w74aybfd05a">
      <p className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-3 gap-y-1 px-5 text-center text-[0.7rem] font-bold uppercase tracking-[0.16em] md:px-8" data-id="element-220" data-mp="2yvn8by2l82kq">
        <HourglassIcon className="h-3.5 w-3.5 text-gold-300" aria-hidden="true" data-id="element-221" data-mp="2p529qamwyy1t" />
        <span data-id="element-222" data-mp="2k6ine94erk8x">La oferta de lanzamiento cierra en:</span>
        <span className="inline-flex items-baseline gap-1.5" role="timer" data-id="element-223" data-mp="2k8239ym5jta6">
          {units.map((unit, index) => <span key={unit.label} className="inline-flex items-baseline gap-1" data-id="element-224" data-mp="2f6mkyebd00vh" data-mpi={index}>
              {index > 0 && <span className="text-plum-300" data-id="element-225" data-mp="2b6m1ugdbf1i3">:</span>}
              <span className="text-sm font-extrabold tabular-nums tracking-normal text-white" data-id="element-226" data-mp="1rx119dgbh8cf">
                {unit.value}
              </span>
              <span className="text-[0.6rem] text-plum-200" data-id="element-227" data-mp="1wpc52re6hea9">{unit.label}</span>
            </span>)}
        </span>
      </p>
    </div>;
}